
import {
    Box,
    IconButton,
    Typography,
    Button,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import Modal from "react-modal";
  import CloseIcon from "@mui/icons-material/Close";
  import { styled } from '@mui/material/styles';

  import {useDispatch } from "react-redux";
  import { toast } from "react-hot-toast";
  import jwtDecode from 'jwt-decode';
  import { useTheme } from '../../ThemeProvider';

    const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      width: "700px",
      maxHeight:'90%',
      transform: "translate(-50%, -50%)",
    },
  };
  


  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });
  const QueryDetail = ({ ModalIsOpen, closeModal,queryData}) => {
    const { theme} = useTheme();

    return (
      <Box sx={{ width: "800px" }}>
        <Modal
          isOpen={ModalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <Box sx={{ padding: "20px" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <div className="w-100 text-start">
                 <p className="h3 my-4 text-start"  style={{color:`${theme==='light' ?'':'white'}`,fontWeight:'600'}}>Query Details</p> 
              </div>
             
              <IconButton onClick={closeModal} aria-label="delete">
                <CloseIcon  sx={{ color:`${theme==='light' ?'':'white'}` }} />
              </IconButton>
            </Box>
          
         
<div className="row  " style={{justifyContent:'space-between'}}>
  <div className="col-md-6 name">
    <p className="m-0 mb-1" style={{fontWeight:'600'}}> Name</p>
    <p>{queryData?.name}</p>
  </div>
  <div className="col-md-6 email">
    <p className="m-0 mb-1" style={{fontWeight:'600'}}>Email</p>
    <p>{queryData?.email}</p>
  </div>
</div>
<div className="mt-3 query">
  <p className="m-0 mb-1" style={{fontWeight:'600'}}>Query</p>
  <p>{queryData?.message}</p>
</div>






            {/* <div className="mt-4">
            <div className="row">
            <div className="col row justify-content-center">
                <div className="col-6 ">
                      <p className="fw-bold"  style={{ color:`${theme==='light' ?'':'white'}`}}>Name</p></div>
                </div>
              
            <div className="col"><p className="inter-300 text-muted"  style={{ fontFamily: `GoogleSans, sans-serif`,textTransform:'capitalize'}} >
                {queryData?.name}</p>
                </div>
         </div>

   <div className="row">
           <div className="col row justify-content-center">
                <div className="col-6 ">
                <p className="fw-bold"  style={{ color:`${theme==='light' ?'':'white'}`}}>Email</p>
                </div>
                </div>
            <div className="col"><p className="inter-300 text-muted"  style={{ fontFamily: `GoogleSans, sans-serif`}}>
                {queryData?.email}</p>
                </div>
         </div>


       
         <div className="row">
           <div className="col row justify-content-center">
                <div className="col-6 ">
                <p className="fw-bold"  style={{ color:`${theme==='light' ?'':'white'}`}}>Query</p>
                </div>
                </div>
            <div className="col">
              <p className="inter-300 text-muted"  style={{ fontFamily: `GoogleSans, sans-serif`}}>
                
                {queryData?.message}
      
                </p></div>
         </div>


    



            </div> */}
            



          </Box>
        </Modal>
      </Box>
    );
  };
  
  export default QueryDetail;
  